import store from 'appRedux/store';
import supporterService from 'services/app/supporter';

const { merge } = supporterService.individual;

const INITIAL_STATE = {};

const setDataFn = () => (state, payload) => {
  return {
    ...payload,
    pagination: payload?.pager,
  };
};

const mergeModels = {
  step1: {
    name: '@app//individual_merge_step1',
    state: INITIAL_STATE, // initial state
    reducers: {
      setData: setDataFn(),
    },
    effects: {
      async get(params) {
        const { data } = await merge.step1(params);
        data.status && this.setData(data);
        return data;
      },
    },
  },
  step2: {
    name: '@app//individual_merge_step2',
    state: INITIAL_STATE, // initial state
    reducers: {
      setData: setDataFn(),
    },
    effects: {
      async get({ co_id, params }) {
        const { data } = await merge.step2(co_id, params);
        data.status && this.setData(data);
        return data;
      },
    },
  },
  cancel: {
    name: '@app//individual_merge_cancel',
    state: INITIAL_STATE, // initial state
    reducers: {
      setData: setDataFn(),
    },
    effects: {
      async proceed(co_id) {
        const { data } = await merge.cancel(co_id);
        data.status && this.setData(data);
        return data;
      },
    },
  },
  step3: {
    name: '@app//individual_merge_step3',
    state: INITIAL_STATE, // initial state
    reducers: {
      setData: setDataFn(),
    },
    effects: {
      async proceed({ co_id, params, payload }) {
        const { data } = await merge.step3(co_id, params, payload);
        return data;
      },
    },
  },
};

store.addModel(mergeModels.step1);
store.addModel(mergeModels.step2);
store.addModel(mergeModels.cancel);
store.addModel(mergeModels.step3);
